export enum parkingLotStatus {
    Available,
    Crowded,
    Full,
    Closed
}